import { Dimensions, Quantity } from '@elderbyte/ngx-starter'
import { Package, PackageState } from './package'

export class PackagePatch {
  public static applyPackageData(packagePatch: PackagePatch, pkg: Package): PackagePatch {
    /* todo field must be only set if it has changed */
    packagePatch.typeId = pkg.typeId
    packagePatch.state = pkg.state
    packagePatch.description = pkg.description
    packagePatch.contentWeight = pkg.contentWeight
    packagePatch.dimensions = pkg.dimensions

    return packagePatch
  }
  public typeId: string
  public state: PackageState
  public description: string
  public contentWeight: Quantity
  public dimensions: Dimensions
  public packagingItems: PackagingItemPatchDto[]

  constructor(public id: string) {}
}
export class PackagingItemPatchDto {
  constructor(
    public materialId: string,
    public quantity: number
  ) {}
}
